import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

const OPACITY_DISPLAY_MIN = 0;
const OPACITY_DISPLAY_MAX = 100;
const OPACITY_MIN = 0;
const OPACITY_MAX = 1;

export function ItemOpacityOption(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemAlpha = useGetKeyFromActiveItem('alpha');

  if (activeItemAlpha === undefined) {
    throw new Error(`Item doesn't have alpha property`);
  }

  const updateAlpha = (alpha: number, undoable = true): void => {
    void activeItem?.updateFromObject(
      {
        alpha,
      },
      {undoable}
    );
  };

  const onChangeOpacity = (updatedValue: number): void => {
    updateAlpha(updatedValue, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateAlpha(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-opacity-options"
      value={activeItemAlpha}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: OPACITY_MIN,
        max: OPACITY_MAX,
      }}
      transformDisplay={{
        min: OPACITY_DISPLAY_MIN,
        max: OPACITY_DISPLAY_MAX,
      }}
      onChange={onChangeOpacity}
      onChangeEnded={onChangeEnded}
    />
  );
}
